"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SocialMediaPlatform = void 0;
var SocialMediaPlatform;
(function (SocialMediaPlatform) {
    SocialMediaPlatform["X"] = "x";
    SocialMediaPlatform["FACEBOOK"] = "facebook";
    SocialMediaPlatform["INSTAGRAM"] = "instagram";
})(SocialMediaPlatform || (exports.SocialMediaPlatform = SocialMediaPlatform = {}));
